import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttp, SCHEMA_VERSION } from '@core/api/api-http';
import { Company, Shareholder } from '../models/company';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private http: ApiHttp) {}

  getSummary(companyId: string): Observable<Company.CompanySummary> {
    return this.http
      .getEntity<Company.SchemaContract>(
        environment.clientsApiUrl,
        `companies/${companyId}`,
        SCHEMA_VERSION.COMPANY,
        ApiHttp.getStandardOptions()
      )
      .pipe(
        map((x) => {
          return {
            id: companyId,
            name: x.name
          };
        })
      );
  }

  deleteCompany(companyId: string): Observable<object> {
    return this.http.deleteEntity(
      environment.clientsApiUrl,
      `companies/${companyId}`,
      SCHEMA_VERSION.COMPANY
    );
  }

  getCompanyDefinition(): Observable<Company.SchemaPropertyDefinition> {
    return this.http.getEntity(
      environment.clientsApiUrl,
      'companies/schema',
      SCHEMA_VERSION.COMPANY,
      ApiHttp.getStandardOptions()
    );
  }

  getShareholderDefinition(): Observable<Shareholder.SchemaPropertyDefinition> {
    return this.http.getEntity(
      environment.clientsApiUrl,
      'companies/schema/shareholders',
      SCHEMA_VERSION.COMPANY,
      ApiHttp.getStandardOptions()
    );
  }

  getCompanyForDisplay(id: string): Observable<Company.Model> {
    return this.http
      .getEntity<Company.SchemaContract>(
        environment.clientsApiUrl,
        `companies/${id}`,
        SCHEMA_VERSION.COMPANY,
        ApiHttp.getStandardOptions()
      )
      .pipe(map((payload) => Company.toModel(id, payload)));
  }

  updateCompany(
    companyId: string,
    change: Partial<Company.Model>
  ): Observable<any> {
    return this.http.put(
      environment.clientsApiUrl,
      `companies/${companyId}`,
      Company.toSchemaContract(change),
      SCHEMA_VERSION.COMPANY,
      ApiHttp.getStandardOptions()
    );
  }
}
